export default __webpack_public_path__ + "static/media/cargoPlane.76f03170.png";